import { cn } from "@/lib/utils";

export function DetailStat({
  label,
  value,
  danger = false,
}: {
  label: string;
  value: string;
  danger?: boolean;
}) {
  return (
    <div className="min-w-0 rounded-lg border border-border bg-card px-3 py-2">
      <p className="text-[10.5px] font-semibold uppercase tracking-wide text-subtle">{label}</p>
      <p
        className={cn(
          "mt-1 truncate text-[12px] font-medium",
          danger ? "text-danger-text" : "text-body",
        )}
      >
        {value}
      </p>
    </div>
  );
}

export function MobileFact({
  label,
  value,
  danger = false,
}: {
  label: string;
  value: string;
  danger?: boolean;
}) {
  return (
    <div className="min-w-0 rounded-lg border border-border bg-surface-muted px-2.5 py-2">
      <p className="text-[10px] font-semibold uppercase tracking-wide text-subtle">{label}</p>
      <p
        className={cn(
          "mt-1 break-words text-[12px] font-medium leading-tight",
          danger ? "text-danger-text" : "text-body",
        )}
      >
        {value}
      </p>
    </div>
  );
}

export function DetailRow({ label, value }: { label: string; value: string }) {
  return (
    <tr className="border-b border-border last:border-0">
      <td className="px-4 py-2 text-[12px] text-muted-foreground">{label}</td>
      <td className="px-4 py-2 text-right text-[12px] font-medium text-body">{value}</td>
    </tr>
  );
}
